/** @todo as exm. */
export enum AppRoutes {
  HOME = '/',
  CHECKOUT = '/checkout',
  CHECKOUT_AUTH = `${AppRoutes.CHECKOUT}/auth`,
  CHECKOUT_GUEST = `${AppRoutes.CHECKOUT}/guest`,
  CHECKOUT_REGISTRATION = `${AppRoutes.CHECKOUT}/registration`,
  KASSE = '/kasse',
  PAYMENT = `${AppRoutes.KASSE}/step2`,
  CONFIRMATION = `${AppRoutes.KASSE}/step3`,
  CART = '/cart',
  ACCOUNT = '/account',
  LOGIN = `${AppRoutes.ACCOUNT}/login`,
  PROFILE = `${AppRoutes.ACCOUNT}/profile`,
  REGISTRATION = `${AppRoutes.ACCOUNT}/registration`,
  RESET_PASSWORD = `${AppRoutes.ACCOUNT}/reset-password`,
  CHANGE_PASSWORD = `${AppRoutes.ACCOUNT}/change-password`,
  RESET_PASSWORD_CONFIRMATION = `${AppRoutes.RESET_PASSWORD}/confirmation`,
  NEWSLETTER = '/newsletter',
  NEWSLETTER_SUBSCRIBE = `${AppRoutes.NEWSLETTER}/subscribe`,
  NEWSLETTER_UNSUBSCRIBE = `${AppRoutes.NEWSLETTER}/unsubscribe`,
  NEWSLETTER_UNSUBSCRIBE_SUCCESS = `${AppRoutes.NEWSLETTER_UNSUBSCRIBE}/success`,
  NEWSLETTER_SUCCESS = `${AppRoutes.NEWSLETTER_SUBSCRIBE}/success`,
  NEWSLETTER_CONFIRMED = `${AppRoutes.NEWSLETTER_SUBSCRIBE}/confirmed`,
  NEWSLETTER_LOGOUT = `${AppRoutes.NEWSLETTER}/logout`,
  SEARCH = '/search',
  LEAVE_REVIEW = '/leave-review',
  WISHLIST = '/wishlist',
  AGB = '/agb',
  RETURN_POLICY = '/widerruf',
  REFUND_POLICY = '/sicherheit-geld-zurueck',
  PRIVACY_POLICY = '/datenschutz',
}
